// Explicit user retries only: blocked networks must never create reload loops.
export function clearLoadingRecovery(document) {
  document.getElementById('loading-recovery')?.remove();
}

export function showLoadingRecovery(document, { message, label, retry }) {
  clearLoadingRecovery(document);
  const panel = document.createElement('div');
  panel.id = 'loading-recovery';
  panel.setAttribute('role', 'alert');
  const text = document.createElement('p');
  text.textContent = message;
  const button = document.createElement('button');
  button.type = 'button';
  button.textContent = label;
  let pending = false;
  button.onclick = async () => {
    if (pending) return;
    pending = true;
    button.disabled = true;
    try { await retry(); }
    catch { /* Keep recovery available if a retry itself cannot complete. */ }
    finally { pending = false; button.disabled = false; }
  };
  panel.append(text, button);
  document.body.append(panel);
  button.focus();
}
